import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { SOLICITACAO_AUTORIZACAO } from './autorizacao-api';
import { map } from 'rxjs/operators';


@Injectable({
    providedIn: 'root'
})

export class DetalhaSolicitacoesService {

    url: string = SOLICITACAO_AUTORIZACAO;

    constructor(private http: HttpClient, private router: Router) { }


    buscaSolicitacaoDetalhada(nuControle): Observable<any> {
        let params = new HttpParams();
        params = params.append('nuControle', nuControle);

       return this.http.get(this.url +'/detalha/solicitacoes/detalhaSolicitacao', { params: params })
                   .pipe(map(res => res));
    }

    buscaListaSolicitacoes(cdUsuario): Observable<any> {
        let params = new HttpParams();
        params = params.append('cdUsuario', cdUsuario);

        return this.http.get(this.url +'/detalha/solicitacoes/listaSolicitacoes', { params: params })
                    .pipe(map(res => res));
     }

    buscaListaAutorizacoes(cdUsuario, cdStatus): Observable<any> {
      let params = new HttpParams();
      if (cdStatus) {
        params = params.append('cdStatus', cdStatus);
      }

      return this.http.get(this.url +'/detalha/solicitacoes/listaAutorizacoes/' + cdUsuario, { params: params })
                  .pipe(map(res => res));
    }

    buscaStatusAutorizacao(): Observable<any> {
      return this.http.get(this.url +'/detalha/solicitacoes/listaStatusAutorizacao')
                  .pipe(map(res => res));
    }

    buscaConfigListaAutorizacoes90dias(): Observable<any> {
      return this.http.get(this.url +'/detalha/solicitacoes/buscaConfigListaAutorizacoes90dias')
                  .pipe(map(res => res));
    }

    salvaArquivos(arquivos:any, nuControle:any): Observable<any> {
        const options = {
            headers: new HttpHeaders({
              'Content-Type': 'application/json'
            })
          };

        return this.http.post(this.url + '/detalha/solicitacoes/salvaArquivos/' + nuControle, arquivos, options)
          .pipe(map(res => res));
    }

    listaArquivos(nuControle: string): Observable<any> {
      return this.http.get(this.url + '/detalha/solicitacoes/listaArquivos/'+nuControle)
           .pipe(map(res => res));
   }

  recuperaArquivo(arquivo:any): Observable<any> {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    return this.http.post(this.url + '/detalha/solicitacoes/recuperaArquivo/', arquivo, options)
      .pipe(map(res => res));
  }
}
